import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import Tournament from "./components/Tournament";
import TournamentDetails from "./components/TournamentDetails";
import AddTournament from "./components/AddTournament";
import UpdateTournament from "./components/UpdateTournament";
import FriendlyMatch from "./components/FriendlyMatch";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/tournament" element={<Tournament />}></Route>
          <Route
            path="/tournament/:tid"
            element={<TournamentDetails />}
          ></Route>
          <Route path="/addTournament" element={<AddTournament />}></Route>
          <Route
            path="/updateTournament/:tid"
            element={<UpdateTournament />}
          ></Route>
          <Route path="/friendlyMatch" element={<FriendlyMatch />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
